<template>
  <div class="move-product-modal">
    <SelectInput
      id="move-product-target-feed"
      label="Doelfeed"
      v-model="selectedFeedId"
      :options="feedOptions"
      :disabled="loading"
    />

    <p v-if="!feedOptions.length" class="move-product-modal__hint">
      Er zijn geen andere feeds beschikbaar om naar te verplaatsen.
    </p>

    <div class="modal__actions">
      <Btn text="Annuleren" variant="outlined" :disabled="loading" @click="handleCancel" />
      <Btn
        text="Verplaatsen"
        variant="primary"
        :loading="loading"
        :disabled="!selectedFeedId"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
  import { ref, computed } from 'vue';
  import SelectInput from '@/components/inputs/SelectInput.vue';
  import Btn from '@/components/partials/Btn.vue';
  import { useUIStore } from '@/store/uiStore';

  export default {
    name: 'MoveProductModal',
    components: { SelectInput, Btn },
    props: {
      modalId: { type: [Number, String], required: true },
      feeds: { type: Array, required: true },
      currentFeedId: { type: String, required: true },
      loading: { type: Boolean, default: false },
      onConfirm: { type: Function, required: true },
    },
    setup(props) {
      const uiStore = useUIStore();

      const feedOptions = computed(() =>
        props.feeds
          .filter((feed) => feed.id !== props.currentFeedId)
          .map((feed) => ({ value: feed.id, label: feed.name }))
      );

      const selectedFeedId = ref(feedOptions.value[0]?.value || '');

      const handleSubmit = () => {
        if (props.loading || !selectedFeedId.value) return;
        props.onConfirm(selectedFeedId.value);
      };

      const handleCancel = () => {
        if (props.loading) return;
        uiStore.closeModal(props.modalId);
      };

      return {
        feedOptions,
        selectedFeedId,
        handleSubmit,
        handleCancel,
      };
    },
  };
</script>

<style scoped lang="scss">
  .move-product-modal {
    &__hint {
      margin-top: 0.5rem;
      font-size: 0.8125rem;
      color: var(--slate-500);
    }

    .modal__actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      margin-top: 1.5rem;
    }
  }
</style>
